import { FeatureGroupType } from '@app/license-management/types/feature-group'
import { LicensePool } from '@app/license-management/types/license-pool'

/**
 * Whether this pool is treated as unlimited in the UI (no finite total / no usage bar).
 * Prefers `label === 'site'`, falls back to non-divisible team pools when label is absent.
 * Mirrors the label-first / legacy-fallback pattern in `getLicensePoolTitle`.
 */
export const isUnlimitedLicensePool = (licensePool: LicensePool): boolean => {
  if (licensePool.label) {
    return licensePool.label === 'site'
  }
  return licensePool.featureGroup?.slug === FeatureGroupType.TEAM && !licensePool.divisible
}
